import React from 'react';

const { FeatureGuard } = window;

export default (featureName) => (component) => {
  class WithFeatureComponent extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        featureResolved: false,
      };
    }

    componentDidMount() {
      FeatureGuard.guard(featureName).then((enabled) => (
        this.setState({
          featureResolved: true,
          featureEnabled: enabled,
        })
      ));
    }

    render() {
      return React.createElement(component, { ...this.props, ...this.state });
    }
  }

  return WithFeatureComponent;
};
